import logger from '../utils/logger';
import React, { useState, useEffect, useContext } from "react";
import "../style/NewImagingOrder.css";
import { GlobalStateContext } from "../utils/GlobalStateContext";
import { Link } from "react-router-dom";
// import { ClinicianContext } from "../utils/ClinicianContext";
import {getUserId, uploadPendingDocuments} from "../utils/utils";
import { InputMask } from '@react-input/mask';
import HGI from '../img/health_guardian.webp';
// import GCSDocumentManager from './customComponents/GCSDocumentManager';
// import "../style/GCSDocumentManager.css";
import GCSDocumentManager from './customComponents/GCSDocumentManager';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useImagingCatalog from '../hooks/useImagingCatalog';
import AddBodyPartModal from './customComponents/AddBodyPartModal';
import AddImagingOrderModal from './customComponents/AddImagingOrderModal';
import ImagingChangeRequestModal from './customComponents/ImagingChangeRequestModal';
import '../style/ImagingModals.css';

// Independent values for modalities and body parts.
const modalities = ["X-Ray","DEXA", "MRI", "CT", "US"];
const listOfBodyParts = [
  "Brain", "Face", "Orbit", "Sinuses", "Neck (Soft Tissue)", "Ear", "Throat",
  "Cervical Spine", "Thoracic Spine", "Lumbar Spine", "Sacrum", "Coccyx",
  "Shoulder", "Humerus", "Elbow", "Forearm", "Wrist", "Hand", "Fingers",
  "Hip", "Femur", "Knee", "Tibia/Fibula", "Ankle", "Foot", "Toes",
  "Chest", "Lungs", "Heart", "Ribs", "Sternum", "Thoracic Aorta",
  "Liver", "Kidneys", "Bladder", "Pancreas", "Pelvis", "Appendix", "GI Tract",
  "Carotid Arteries", "Abdominal Aorta", "Peripheral Arteries",
  "Venous Doppler Lower Extremities", "Renal Arteries",
  "Extremities", "Neck", "Abdomen", "Orbits"
];

const listOfRegions = [
  "Head & Neck",
  "Spine",
  "Upper Extremity",
  "Lower Extremity",
  "Chest / Thorax",
  "Abdomen / Pelvis",
  "Vascular",
  "Soft Tissue / Foreign Body",
  "Full Body",
];

const regionBodyPartsMap = {
  "Head & Neck": [
    "Brain", "Face", "Orbit", "Sinuses", "Neck (Soft Tissue)", "Ear", "Throat",
    "Carotid Arteries", "Orbits"
  ],

  "Spine": [
    "Cervical Spine", "Thoracic Spine", "Lumbar Spine", "Sacrum", "Coccyx"
  ],

  "Upper Extremity": [
    "Shoulder", "Humerus", "Elbow", "Forearm", "Wrist", "Hand", "Fingers"
  ],

  "Lower Extremity": [
    "Hip", "Legs", "Femur", "Knee", "Tibia/Fibula", "Ankle", "Foot", "Toes",
    "Venous Doppler Lower Extremities"
  ],

  "Chest / Thorax": [
    "Chest", "Lungs", "Heart", "Ribs", "Sternum", "Thoracic Aorta"
  ],

  "Abdomen / Pelvis": [
    "Liver", "Kidneys", "Bladder", "Pancreas", "Pelvis", "Appendix", "GI Tract",
    "Abdomen"
  ],

  "Vascular": [
    "Carotid Arteries", "Abdominal Aorta", "Peripheral Arteries",
    "Renal Arteries"
  ],

  "Soft Tissue / Foreign Body": [
    "Extremities", "Neck", "Soft Tissue", "Foreign Body"
  ],

  "Full Body": [
    "Full Body"
  ]
};

const anatomicalMap = {
  "Head & Neck": [
      //{ code: "70551", name: "MRI brain w/o contrast", modality: "MRI" },
      //{ code: "70552", name: "MRI brain w/ contrast", modality: "MRI" },
      //{ code: "70450", name: "CT brain w/o contrast", modality: "CT" },
      //{ code: "70460", name: "CT brain w/ contrast", modality: "CT" }
      { id: 1, code: "70450", name: "CT head (non-contrast)", modality: "CT"},
      { id: 2, code: "70470", name: "CT head w/o and w/ contrast", modality: "CT"},
      { id: 3, code: "70496", name: "CT Angiogram (CTA) Head", modality: "CT"},
      { id: 4, code: "70551", name: "MRI Brain w/o contrast", modality: "MRI"},
      { id: 5, code: "70552", name: "MRI Brain w/o and w/ contrast", modality: "MRI"},
      { id: 6, code: "70553", name: "MRI Brain w/o and w/ contrast", modality: "MRI"},
      { id: 7, code: "70553", name: "MRI Brain w/o and w/ Pituitary Protocol", modality: "MRI"},
      { id: 8, code: "70553", name: "MRI Brain w/o and w/ Epilepsy Protocol", modality: "MRI"},
      { id: 9, code: "70544", name: "MRA Head w/o and w/ contrast", modality: "MRI"},
      { id: 10, code: "70544", name: "MRA Circle of Willis", modality: "MRI"},
      { id: 11, code: "70260", name: "Skull (4 views)", modality: "X-Ray"},
      { id: 12, code: "77085", name: "Fracture Assessment", modality: "DEXA" },

  

      //{ code: "70486", name: "CT maxillofacial area w/o contrast", modality: "CT" },
      //{ code: "70487", name: "CT maxillofacial area w/ contrast", modality: "CT" }
      { id: 13, code: "70486", name: "Facial CT w/o contrast", modality: "CT"},
      { id: 14, code: "70487", name: "Facial CT w/ contrast", modality: "CT"},
      { id: 15, code: "70488", name: "Facial CT w/o and w/ contrast", modality: "CT"},
      { id: 16, code: "70150", name: "Facial Bones (3 views)", modality: "X-Ray"},
      { id: 17, code: "76536", name: "Ultrasound Parotid Glands Left", modality: "US"},
      { id: 18, code: "76536", name: "Ultrasound Parotid Glands Right", modality: "US"},
      { id: 19, code: "76536", name: "Ultrasound Parotid Glands Both", modality: "US"},
      { id: 20, code: "77085", name: "Fracture Assessment", modality: "DEXA" },
  
      //{ code: "70540", name: "MRI orbit/face/neck w/o contrast", modality: "MRI" },
      //{ code: "70480", name: "CT orbit w/o contrast", modality: "CT" }
      { id: 21, code: "77085", name: "Fracture Assessment", modality: "DEXA" },

      { id: 22, code: "70486", name: "CT sinus w/o contrast", modality: "CT" },
      { id: 23, code: "70487", name: "CT sinus w/ contrast", modality: "CT" },
      { id: 24, code: "70488", name: "CT sinus w/o and w/ contrast", modality: "CT" },
      { id: 25, code: "70540", name: "MRI Sinuses w/o contrast", modality: "MRI"},
      // { code: "70540", name: "MRI Sinuses w/ contrast", modality: "MRI"},
      { id: 26, code: "70540", name: "MRI Sinuses w/o and w/ contrast", modality: "MRI"},
      { id: 27, code: "70220", name: "Sinuses (Waters view)", modality: "X-Ray"},
      { id: 28, code: "70160", name: "Nasal Bones (2-3 views)", modality: "X-Ray"},
 
      { id: 29, code: "70498", name: "CT Angiogram (CTA) Neck", modality: "CT"},
      { id: 30, code: "70490", name: "CT Neck w/o contrast", modality: "CT"},
      { id: 31, code: "70491", name: "CT Neck w/ contrast", modality: "CT"},
      { id: 32, code: "70492", name: "CT Neck w/o and w/ contrast", modality: "CT"},
      { id: 33, code: "70547", name: "MRA Neck w/o and w/ contrast", modality: "MRI"},
      { id: 34, code: "76536", name: "Ultrasound thyroid", modality: "US"},
      { id: 35, code: "76536", name: "Ultrasound neck", modality: "US"},
      { id: 36, code: "76536", name: "Ultrasound Submandibular Glands Left", modality: "US"},
      { id: 37, code: "76536", name: "Ultrasound Submandibular Glands Right", modality: "US"},
      { id: 38, code: "76536", name: "Ultrasound Submandibular Glands Both", modality: "US"},
      // { code: "77085", name: "Fracture Assessment", modality: "DEXA" },

      //{ code: "70140", name: "X-ray mastoids", modality: "X-Ray" }

      //{ code: "70371", name: "Modified barium swallow study", modality: "Fluoro" }
  
  ],
  "Spine": [
      //{ code: "72141", name: "MRI cervical spine w/o contrast", modality: "MRI" },
      //{ code: "72040", name: "X-ray cervical spine 2-3 views", modality: "X-Ray" }
      { id: 39, code: "72125", name: "CT Cervical Spine w/o Contrast", modality: "CT" },
      { id: 40, code: "72126", name: "CT Cervical Spine w/ Contrast", modality: "CT" },
      { id: 41, code: "72127", name: "CT Cervical Spine w/o and w/ Contrast", modality: "CT" },
      { id: 42, code: "72141", name: "MRI Cervical Spine w/o contrast", modality: "MRI"},
      // { code: "72142", name: "MRI Cervical Spine w/ contrast", modality: "MRI"},
      { id: 43, code: "72156", name: "MRI Cervical Spine w/o and w/ contrast", modality: "MRI"},
      { id: 44, code: "72040", name: "Cervical Spine (2-3 views)", modality: "X-Ray" },
      { id: 45, code: "77085", name: "Fracture Assessment", modality: "DEXA" },
   
      //{ code: "72146", name: "MRI thoracic spine w/o contrast", modality: "MRI" },
      // { code: "72070", name: "X-ray thoracic spine 2 views", modality: "X-Ray" }
      { id: 46, code: "72128", name: "CT Thoracic Spine w/o contrast", modality: "CT" },
      { id: 47, code: "72129", name: "CT Thoracic Spine w/ contrast", modality: "CT" },
      { id: 48, code: "72130", name: "CT Thoracic Spine w/o and w/ contrast", modality: "CT" },
      { id: 49, code: "72146", name: "MRI Thoracic Spine w/o contrast", modality: "MRI"},
      // { code: "72147", name: "MRI Thoracic Spine w/ contrast", modality: "MRI"},
      { id: 50, code: "72157", name: "MRI Thoracic Spine w/o and w/ contrast", modality: "MRI"},
      { id: 51, code: "72070", name: "Thoracic Spine (2 views)", modality: "X-Ray" },
      { id: 52, code: "72082", name: "Scoliosis Series (Ap and lateral)", modality: "X-Ray"},
      { id: 53, code: "72082", name: "Scoliosis Series (2 views)", modality: "X-Ray"},
      { id: 54, code: "77085", name: "Fracture Assessment", modality: "DEXA" },
 
      //{ code: "72148", name: "MRI lumbar spine w/o contrast", modality: "MRI" },
      //{ code: "72149", name: "MRI lumbar spine w/ contrast", modality: "MRI" },
      //{ code: "72158", name: "MRI lumbar spine w/ & w/o contrast", modality: "MRI" }
      { id: 55, code: "72131", name: "CT Lumbar Spine w/o contrast", modality: "CT" },
      { id: 56, code: "72132", name: "CT Lumbar Spine w/ contrast", modality: "CT" },
      { id: 57, code: "72133", name: "CT Lumbar Spine w/o and w/ contrast", modality: "CT" },
      { id: 58, code: "72148", name: "MRI Lumbar Spine w/o contrast", modality: "MRI" },
      // { code: "72149", name: "MRI Lumbar Spine w/ contrast", modality: "MRI" },
      { id: 59, code: "72158", name: "MRI Lumbar Spine w/o and w/ contrast", modality: "MRI" },
      { id: 60, code: "72100", name: "Lumbar Spine (2-3 views)", modality: "X-Ray" },
      { id: 61, code: "72082", name: "Scoliosis Series (Ap and lateral)", modality: "X-Ray"},
      { id: 62, code: "72082", name: "Scoliosis Series (2 views)", modality: "X-Ray"},
      { id: 63, code: "77085", name: "Fracture Assessment", modality: "DEXA" },
    
      //{ code: "72195", name: "MRI pelvis/sacrum w/o contrast", modality: "MRI" }
      { id: 64, code: "72133", name: "CT Sacrum w/ contrast", modality: "CT"},
      { id: 65, code: "72132", name: "CT Sacrum w/o contrast", modality: "CT"},
      { id: 66, code: "72133", name: "CT Sacrum w/o and w/ contrast", modality: "CT"},
      { id: 67, code: "72195", name: "MRI Sacrum/Sacroiliac Joints w/ contrast", modality: "MRI"},
      { id: 68, code: "72196", name: "MRI Sacrum/Sacroiliac Joints w/o contrast", modality: "MRI"},
      { id: 69, code: "72197", name: "MRI Sacrum/Sacroiliac Joints w/o and w/ contrast", modality: "MRI"},
      { id: 70, code: "72220", name: "Sacrum/Coccyx (2 views)", modality: "X-Ray" },
      { id: 71, code: "77085", name: "Fracture Assessment", modality: "DEXA" },
   
      //{ code: "72202", name: "X-ray coccyx", modality: "X-Ray" }
      { id: 72, code: "72220", name: "Sacrum/Coccyx (2 views)", modality: "X-Ray" },
      { id: 73, code: "77085", name: "Fracture Assessment", modality: "DEXA" },
    ],
  "Upper Extremity": [
      //{ code: "73221", name: "MRI shoulder w/o contrast", modality: "MRI" },
      //{ code: "73030", name: "X-ray shoulder complete", modality: "X-Ray" }
      { id: 74, code: "73200", name: "CT Left Shoulder w/o contrast", modality: "CT"},
      { id: 75, code: "73200", name: "CT Right Shoulder w/o contrast", modality: "CT"},
      { id: 76, code: "73200", name: "CT Both Shoulders w/o contrast", modality: "CT"},
      { id: 77, code: "73201", name: "CT Left Shoulder w/ contrast", modality: "CT"},
      { id: 78, code: "73201", name: "CT Right Shoulder w/ contrast", modality: "CT"},
      { id: 79, code: "73201", name: "CT Both Shoulders w/ contrast", modality: "CT"},
      { id: 80, code: "73202", name: "CT Left Shoulder w/o and w/ contrast", modality: "CT"},
      { id: 81, code: "73202", name: "CT Right Shoulder w/o and w/ contrast", modality: "CT"},
      { id: 82, code: "73202", name: "CT Both Shoulders w/o and w/ contrast", modality: "CT"},
      { id: 83, code: "73221", name: "MRI Left Shoulder w/o contrast", modality: "MRI"},
      { id: 84, code: "73221", name: "MRI Right Shoulder w/o contrast", modality: "MRI"},
      { id: 85, code: "73221", name: "MRI Both Shoulders w/o contrast", modality: "MRI"},
      { id: 86, code: "73223", name: "MRI Left Shoulder w/o and w/ contrast", modality: "MRI"},
      { id: 87, code: "73223", name: "MRI Right Shoulder w/o and w/ contrast", modality: "MRI"},
      { id: 88, code: "73223", name: "MRI Both Shoulders w/o and w/ contrast", modality: "MRI"},
      { id: 89, code: "73225", name: "MRA Left Shoulder", modality: "MRI"},
      { id: 90, code: "73225", name: "MRA Right Shoulder", modality: "MRI"},
      { id: 91, code: "73225", name: "MRA Both Shoulders", modality: "MRI"},
      { id: 92, code: "73030", name: "Left Shoulder 2 view", modality: "X-Ray" },
      { id: 93, code: "73030", name: "Right Shoulder 2 view", modality: "X-Ray" },
      { id: 94, code: "73030", name: "Both Shoulders 2 view", modality: "X-Ray" },
      { id: 95, code: "73030", name: "Left Shoulder 3 view", modality: "X-Ray" },
      { id: 96, code: "73030", name: "Right Shoulder 3 view", modality: "X-Ray" },
      { id: 97, code: "73030", name: "Both Shoulders 3 view", modality: "X-Ray" },
      { id: 98, code: "73000", name: "Left Clavicle (Ap and axial)", modality: "X-Ray"},
      { id: 99, code: "73000", name: "Right Clavicle (Ap and axial)", modality: "X-Ray"},
      { id: 100, code: "73000", name: "Both Clavicles (Ap and axial)", modality: "X-Ray"},
      { id: 101, code: "73000", name: "Left Clavicle (2 views)", modality: "X-Ray"},
      { id: 102, code: "73000", name: "Right Clavicle (2 views)", modality: "X-Ray"},
      { id: 103, code: "73000", name: "Both Clavicles (2 views)", modality: "X-Ray"},
      { id: 104, code: "73000", name: "Left Clavicle (Ap and axial)", modality: "X-Ray"},
      { id: 105, code: "73000", name: "Right Clavicle (Ap and axial)", modality: "X-Ray"},
      { id: 106, code: "73000", name: "Both Clavicles (Ap and axial)", modality: "X-Ray"},
      { id: 107, code: "73010", name: "Left Scapula (AP and lateral)", modality: "X-Ray"},
      { id: 108, code: "73010", name: "Right Scapula (AP and lateral)", modality: "X-Ray"},
      { id: 109, code: "73010", name: "Both Scapulas (AP and lateral)", modality: "X-Ray"},
      { id: 110, code: "73010", name: "Left Scapula (2 views)", modality: "X-Ray"},
      { id: 111, code: "73010", name: "Right Scapula (2 views)", modality: "X-Ray"},
      { id: 112, code: "73010", name: "Both Scapulas (2 views)", modality: "X-Ray"},
      { id: 113, code: "73050", name: "Both AC Joints", modality: "X-Ray"},
      { id: 114, code: "76881", name: "Ultrasound Shoulder Left Complete", modality: "US"},
      { id: 115, code: "76881", name: "Ultrasound Shoulder Right Complete", modality: "US"},
      { id: 116, code: "76881", name: "Ultrasound Shoulder Both Complete", modality: "US"},
      { id: 117, code: "76882", name: "Ultrasound Shoulder Left Limited", modality: "US"},
      { id: 118, code: "76882", name: "Ultrasound Shoulder Right Limited", modality: "US"},
      { id: 119, code: "76882", name: "Ultrasound Shoulder Both Limited", modality: "US"},
      { id: 120, code: "76641", name: "Ultrasound Axilla Left Complete", modality: "US"},
      { id: 121, code: "76641", name: "Ultrasound Axilla Right Complete", modality: "US"},
      { id: 122, code: "76641", name: "Ultrasound Axilla Both Complete", modality: "US"},
      { id: 123, code: "76642", name: "Ultrasound Axilla Left Limited", modality: "US"},
      { id: 124, code: "76642", name: "Ultrasound Axilla Right Limited", modality: "US"},
      { id: 125, code: "76642", name: "Ultrasound Axilla Both Limited", modality: "US"},
      { id: 126, code: "77080", name: "Dexa Axial", modality: "DEXA"},
      { id: 127, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 128, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },

      //{ id: 125, code: "73060", name: "X-ray humerus 2 views", modality: "X-Ray" }
      { id: 129, code: "73200", name: "CT Left Humerus w/o contrast", modality: "CT"},
      { id: 130, code: "73200", name: "CT Right Humerus w/o contrast", modality: "CT"},
      { id: 131, code: "73200", name: "CT Both Humerus w/o contrast", modality: "CT"},
      { id: 132, code: "73201", name: "CT Left Humerus w/ contrast", modality: "CT"},
      { id: 133, code: "73201", name: "CT Right Humerus w/ contrast", modality: "CT"},
      { id: 134, code: "73201", name: "CT Both Humerus w/ contrast", modality: "CT"},
      { id: 135, code: "73202", name: "CT Left Humerus w/o and w/ contrast", modality: "CT"},
      { id: 136, code: "73202", name: "CT Right Humerus w/o and w/ contrast", modality: "CT"},
      { id: 137, code: "73202", name: "CT Both Humerus w/o and w/ contrast", modality: "CT"},
      { id: 138, code: "73060", name: "Left Humerus (AP and lateral)", modality: "X-Ray"},
      { id: 139, code: "73060", name: "Right Humerus (AP and lateral)", modality: "X-Ray"},
      { id: 140, code: "73060", name: "Both Humerus (AP and lateral)", modality: "X-Ray"},
      { id: 141, code: "73060", name: "Left Humerus (2 views)", modality: "X-Ray"},
      { id: 142, code: "73060", name: "Right Humerus (2 views)", modality: "X-Ray"},
      { id: 143, code: "73060", name: "Both Humerus (2 views)", modality: "X-Ray"},
      { id: 144, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 145, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },

      //{ id: 145, code: "73080", name: "X-ray elbow complete", modality: "X-Ray" }
      { id: 146, code: "73200", name: "CT Left Elbow w/o contrast", modality: "CT"},
      { id: 147, code: "73200", name: "CT Right Elbow w/o contrast", modality: "CT"},
      { id: 148, code: "73200", name: "CT Both Elbows w/o contrast", modality: "CT"},
      { id: 149, code: "73201", name: "CT Left Elbow w/ contrast", modality: "CT"},
      { id: 150, code: "73201", name: "CT Right Elbow w/ contrast", modality: "CT"},
      { id: 151, code: "73201", name: "CT Both Elbows w/ contrast", modality: "CT"},
      { id: 152, code: "73202", name: "CT Left Elbow w/o and w/ contrast", modality: "CT"},
      { id: 153, code: "73202", name: "CT Right Elbow w/o and w/ contrast", modality: "CT"},
      { id: 154, code: "73202", name: "CT Both Elbows w/o and w/ contrast", modality: "CT"},
      { id: 155, code: "73200", name: "MRI Left Elbow w/o contrast", modality: "MRI"},
      // { code: "73200", name: "MRI Left Elbow w/ contrast", modality: "MRI"},
      { id: 156, code: "73200", name: "MRI Left Elbow w/o and w/ contrast", modality: "MRI"},
      { id: 157, code: "73200", name: "MRI Right Elbow w/o contrast", modality: "MRI"},
      // { code: "73200", name: "MRI Right Elbow w/ contrast", modality: "MRI"},
      { id: 158, code: "73200", name: "MRI Right Elbow w/o and w/ contrast", modality: "MRI"},
      { id: 159, code: "73200", name: "MRI Both Elbows w/o contrast", modality: "MRI"},
      // { code: "73200", name: "MRI Both Elbows w/ contrast", modality: "MRI"},
      { id: 160, code: "73200", name: "MRI Both Elbows w/o and w/ contrast", modality: "MRI"},
      { id: 161, code: "72220", name: "Cacrum/Coccyx (2 views)", modality: "X-Ray" },
      { id: 162, code: "73080", name: "Left Elbow AP", modality: "X-Ray" },
      { id: 163, code: "73080", name: "Right Elbow AP", modality: "X-Ray" },
      { id: 164, code: "73080", name: "Both Elbows AP", modality: "X-Ray" },
      { id: 165, code: "73080", name: "Left Elbow Lateral", modality: "X-Ray" },
      { id: 166, code: "73080", name: "Right Elbow Lateral", modality: "X-Ray" },
      { id: 167, code: "73080", name: "Both Elbows Lateral", modality: "X-Ray" },
      { id: 168, code: "73080", name: "Left Elbow Greenspan", modality: "X-Ray" },
      { id: 169, code: "73080", name: "Right Elbow Greenspan", modality: "X-Ray" },
      { id: 170, code: "73080", name: "Both Elbows Greenspan", modality: "X-Ray" },
      { id: 171, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 172, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },

      //{ code: "77080", name: "DEXA forearm scan", modality: "DEXA" },
      //{ code: "73090", name: "X-ray forearm 2 views", modality: "X-Ray" }
      { id: 173, code: "73200", name: "CT Left Forearm w/o contrast", modality: "CT"},
      { id: 174, code: "73200", name: "CT Right Forearm w/o contrast", modality: "CT"},
      { id: 175, code: "73200", name: "CT Both Forearms w/o contrast", modality: "CT"},
      { id: 176, code: "73201", name: "CT Left Forearm w/ contrast", modality: "CT"},
      { id: 177, code: "73201", name: "CT Right Forearm w/ contrast", modality: "CT"},
      { id: 178, code: "73201", name: "CT Both Forearms w/ contrast", modality: "CT"},
      { id: 179, code: "73202", name: "CT Left Forearm w/o and w/ contrast", modality: "CT"},
      { id: 180, code: "73202", name: "CT Right Forearm w/o and w/ contrast", modality: "CT"},
      { id: 181, code: "73202", name: "CT Both Forearms w/o and w/ contrast", modality: "CT"},
      { id: 182, code: "73090", name: "Forearm AP and Lateral", modality: "X-Ray" },
      { id: 183, code: "76641", name: "Ultrasound Axilla Left Complete", modality: "US"},
      { id: 184, code: "76641", name: "Ultrasound Axilla Right Complete", modality: "US"},
      { id: 185, code: "76641", name: "Ultrasound Axilla Both Complete", modality: "US"},
      { id: 186, code: "76642", name: "Ultrasound Axilla Left Limited", modality: "US"},
      { id: 187, code: "76642", name: "Ultrasound Axilla Right Limited", modality: "US"},
      { id: 188, code: "76642", name: "Ultrasound Axilla Both Limited", modality: "US"},
      { id: 189, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 190, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },

      //{ id: 190, code: "73100", name: "X-ray wrist 2 views", modality: "X-Ray" }
      { id: 191, code: "73221", name: "CT Left Wrist w/o contrast", modality: "CT"},
      { id: 192, code: "73221", name: "CT Right Wrist w/o contrast", modality: "CT"},
      { id: 193, code: "73221", name: "CT Both Wrists w/o contrast", modality: "CT"},
      { id: 194, code: "73222", name: "CT Left Wrist w/ contrast", modality: "CT"},
      { id: 195, code: "73222", name: "CT Right Wrist w/ contrast", modality: "CT"},
      { id: 196, code: "73222", name: "CT Both Wrists w/ contrast", modality: "CT"},
      { id: 197, code: "73223", name: "CT Left Wrist w/o and w/ contrast", modality: "CT"},
      { id: 198, code: "73223", name: "CT Right Wrist w/o and w/ contrast", modality: "CT"},
      { id: 199, code: "73223", name: "CT Both Wrists w/o and w/ contrast", modality: "CT"},
      { id: 200, code: "73200", name: "MRI Left Wrist w/o contrast", modality: "MRI"},
      { id: 201, code: "73200", name: "MRI Right Wrist w/o contrast", modality: "MRI"},
      { id: 202, code: "73200", name: "MRI Both Wrists w/o contrast", modality: "MRI"},
      { id: 203, code: "73110", name: "Left Wrist (3 views)", modality: "X-Ray"},
      { id: 204, code: "73110", name: "Right Wrist (3 views)", modality: "X-Ray"},
      { id: 205, code: "73110", name: "Both Wrists (3 views)", modality: "X-Ray"},
      { id: 206, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 207, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },

      //{ code: "73120", name: "X-ray hand 2 views", modality: "X-Ray" }
      { id: 208, code: "73200", name: "CT Left Hand w/o contrast", modality: "CT"},
      { id: 209, code: "73200", name: "CT Right Hand w/o contrast", modality: "CT"},
      { id: 210, code: "73200", name: "CT Both Hands w/o contrast", modality: "CT"},
      { id: 211, code: "73201", name: "CT Left Hand w/ contrast", modality: "CT"},
      { id: 212, code: "73201", name: "CT Right Hand w/ contrast", modality: "CT"},
      { id: 213, code: "73201", name: "CT Both Hands w/ contrast", modality: "CT"},
      { id: 214, code: "73202", name: "CT Left Hand w/o and w/ contrast", modality: "CT"},
      { id: 215, code: "73202", name: "CT Right Hand w/o and w/ contrast", modality: "CT"},
      { id: 216, code: "73202", name: "CT Both Hands w/o and w/ contrast", modality: "CT"},
      { id: 217, code: "73200", name: "MRI Left Hand w/o contrast", modality: "MRI"},
      // { code: "73200", name: "MRI Left Hand w/ contrast", modality: "MRI"},
      { id: 218, code: "73200", name: "MRI Left Hand w/o and w/ contrast", modality: "MRI"},
      { id: 219, code: "73200", name: "MRI Right Hand w/o contrast", modality: "MRI"},
      // { code: "73200", name: "MRI Right Hand w/ contrast", modality: "MRI"},
      { id: 220, code: "73200", name: "MRI Right Hand w/o and w/ contrast", modality: "MRI"},
      { id: 221, code: "73200", name: "MRI Both Hands w/o contrast", modality: "MRI"},
      // { code: "73200", name: "MRI Both Hands w/ contrast", modality: "MRI"},
      { id: 222, code: "73200", name: "MRI Both Hands w/o and w/ contrast", modality: "MRI"},
      { id: 223, code: "73130", name: "Left Hand (3 views)", modality: "X-Ray"},
      { id: 224, code: "73130", name: "Right Hand (3 views)", modality: "X-Ray"},
      { id: 225, code: "73130", name: "Both Hands (3 views)", modality: "X-Ray"},
      { id: 226, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 227, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },

      //{ code: "73140", name: "X-ray finger(s)", modality: "X-Ray" }
      { id: 228, code: "73200", name: "CT Left Fingers 1-5 w/o contrast", modality: "CT"},
      { id: 229, code: "73200", name: "CT Right Fingers 1-5 w/o contrast", modality: "CT"},
      { id: 230, code: "73201", name: "CT Left Fingers 1-5 w/ contrast", modality: "CT"},
      { id: 231, code: "73201", name: "CT Right Fingers 1-5 w/ contrast", modality: "CT"},
      { id: 232, code: "73202", name: "CT Left Fingers 1-5 w/o and w/ contrast", modality: "CT"},
      { id: 233, code: "73202", name: "CT Right Fingers 1-5 w/o and w/ contrast", modality: "CT"},
      { id: 234, code: "73200", name: "MRI Left Fingers 1-5 w/o contrast", modality: "MRI"},
      { id: 235, code: "73200", name: "MRI Right Fingers 1-5 w/o contrast", modality: "MRI"},
      { id: 236, code: "73140", name: "Left Fingers 1-5 (2-3 views)", modality: "X-Ray"},
      { id: 237, code: "73140", name: "Right Fingers 1-5 (2-3 views)", modality: "X-Ray"},
      { id: 238, code: "77085", name: "Fracture Assessment Left 1-5", modality: "DEXA" },
      { id: 239, code: "77085", name: "Fracture Assessment Right 1-5", modality: "DEXA" },
    ],
  "Lower Extremity": [
      // { code: "73721", name: "MRI hip w/o contrast", modality: "MRI" },
      //{ code: "73560", name: "X-ray hip 1 view", modality: "X-Ray" },
      { id: 240, code: "73700", name: "MRI Left Hip w/o contrast", modality: "MRI"},
      { id: 241, code: "73700", name: "CT Left Hip w/o contrast", modality: "CT"},
      { id: 242, code: "73700", name: "CT Right Hip w/o contrast", modality: "CT"},
      // { code: "73700", name: "MRI Left Hip w/ contrast", modality: "MRI"},
      { id: 243, code: "73700", name: "MRI Right Hip w/o contrast", modality: "MRI"},
      // { code: "73700", name: "MRI Right Hip w/ contrast", modality: "MRI"},
      { id: 244, code: "73700", name: "MRI Both Hips w/o contrast", modality: "MRI"},
      // { code: "73700", name: "MRI Both Hips w/o and w/ contrast", modality: "MRI"},
      { id: 245, code: "73702", name: "MRI Left Hip w/o and w/ contrast", modality: "MRI"},
      { id: 246, code: "73702", name: "MRI Right Hip w/o and w/ contrast", modality: "MRI"},
      { id: 247, code: "73702", name: "MRI Both Hips w/o and w/ contrast", modality: "MRI"},
      { id: 248, code: "73502", name: "Left Hip (AP and lateral, 2 views)", modality: "X-Ray" },
      { id: 249, code: "73502", name: "Right Hip (AP and lateral, 2 views)", modality: "X-Ray" },
      { id: 250, code: "73521", name: "Bilateral Hips (AP and lateral, 2 views each)", modality: "X-Ray" },
      { id: 251, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 252, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },

      //{ code: "73550", name: "X-ray femur 2 views", modality: "X-Ray" }
      { id: 253, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      { id: 254, code: "73552", name: "Left Femur AP and Lateral", modality: "X-Ray" },
      { id: 255, code: "73552", name: "Right Femur AP and Lateral", modality: "X-Ray" },
      { id: 256, code: "73552", name: "Both Femurs AP and Lateral", modality: "X-Ray" },
      { id: 257, code: "73552", name: "Left Femur 2 views", modality: "X-Ray" },
      { id: 258, code: "73552", name: "Right Femur 2 views", modality: "X-Ray" },
      { id: 259, code: "73552", name: "Both Femurs 2 views", modality: "X-Ray" },
      { id: 260, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 261, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },
      { id: 262, code: "73718", name: "MRI Femur w/o contrast", modality: "MRI" },
      { id: 263, code: "73700", name: "CT Left Femur w/o contrast", modality: "CT" },
      { id: 264, code: "73700", name: "CT Right Femur w/o contrast", modality: "CT" },
      { id: 265, code: "73719", name: "MRI Femur w/ contrast", modality: "MRI" },
      { id: 266, code: "73720", name: "MRI Femur w/o and w/ contrast", modality: "MRI" },

      //{ id: 260, code: "73721", name: "MRI knee w/o contrast", modality: "MRI" },
      //{ id: 260, code: "73562", name: "X-ray knee 3 views", modality: "X-Ray" }
      { id: 267, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      { id: 268, code: "73700", name: "MRI Left Knee w/o contrast", modality: "MRI"},
      { id: 269, code: "73700", name: "CT Left Knee w/o contrast", modality: "CT"},
      { id: 270, code: "73700", name: "CT Right Knee w/o contrast", modality: "CT"},
      // { id: 270, code: "73700", name: "MRI Left Knee w/ contrast", modality: "MRI"},
      { id: 271, code: "73700", name: "MRI Right Knee w/o contrast", modality: "MRI"},
      // { id: 270, code: "73700", name: "MRI Right Knee w/ contrast", modality: "MRI"},
      { id: 272, code: "73700", name: "MRI Both Knees w/o contrast", modality: "MRI"},
      // { id: 270, code: "73700", name: "MRI Both Knees w/ contrast", modality: "MRI"},
      { id: 273, code: "73702", name: "MRI Left Knee w/o and w/ contrast", modality: "MRI"},
      { id: 274, code: "73702", name: "MRI Right Knee w/o and w/ contrast", modality: "MRI"},
      { id: 275, code: "73702", name: "MRI Both Knees w/o and w/ contrast", modality: "MRI"},
      { id: 276, code: "73562", name: "Left Knee (3-4 views)", modality: "X-Ray" },
      { id: 277, code: "73562", name: "Right Knee (3-4 views)", modality: "X-Ray" },
      { id: 278, code: "73562", name: "Both Knees (3-4 views)", modality: "X-Ray" },
      { id: 279, code: "73560", name: "Left Patella (sunrise and lateral)", modality: "X-Ray"},
      { id: 280, code: "73560", name: "Right Patella (sunrise and lateral)", modality: "X-Ray"},
      { id: 281, code: "73560", name: "Both Patellas (sunrise and lateral)", modality: "X-Ray"},
      { id: 282, code: "73560", name: "Left Patella (2 views)", modality: "X-Ray "},
      { id: 283, code: "73560", name: "Right Patella (2 views)", modality: "X-Ray "},
      { id: 284, code: "73560", name: "Both Patellas (2 views)", modality: "X-Ray "},
      { id: 285, code: "76881", name: "Ultrasound Knee Left Complete", modality: "US" },
      { id: 286, code: "76881", name: "Ultrasound Knee Right Complete", modality: "US" },
      { id: 287, code: "76881", name: "Ultrasound Knee Both Complete", modality: "US" },
      { id: 288, code: "76882", name: "Ultrasound Knee Left Limited", modality: "US" },
      { id: 289, code: "76882", name: "Ultrasound Knee Right Limited", modality: "US" },
      { id: 290, code: "76882", name: "Ultrasound Knee Both Limited", modality: "US" },
      { id: 291, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 292, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },
    // ],
    // "Tibia/Fibula": [
      //{ code: "73590", name: "X-ray lower leg (tibia/fibula)", modality: "X-Ray" }
      { id: 293, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      { id: 294, code: "73590", name: "Left Tibia/Fibula AP and Lateral", modality: "X-Ray" },
      { id: 295, code: "73590", name: "Right Tibia/Fibula AP and Lateral", modality: "X-Ray" },
      { id: 296, code: "73590", name: "Both Tibia/Fibulas AP and Lateral", modality: "X-Ray" },
      { id: 297, code: "73590", name: "Left Tibia/Fibula 2 views", modality: "X-Ray" },
      { id: 298, code: "73590", name: "Right Tibia/Fibula 2 views", modality: "X-Ray" },
      { id: 299, code: "73590", name: "Both Tibia/Fibulas 2 views", modality: "X-Ray" },
      { id: 300, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 301, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },
    // ],
    // "Ankle": [
      //{ code: "73610", name: "X-ray ankle 3 views", modality: "X-Ray" }
      { id: 302, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      { id: 303, code: "73700", name: "MRI Left Ankle w/o contrast", modality: "MRI"},
      { id: 304, code: "73700", name: "CT Left Ankle w/o contrast", modality: "CT"},
      { id: 305, code: "73700", name: "CT Right Ankle w/o contrast", modality: "CT"},
      // { code: "73700", name: "MRI Left Ankle w/ contrast", modality: "MRI"},
      { id: 306, code: "73700", name: "MRI Left Ankle w/o and w/ contrast", modality: "MRI"},
      { id: 307, code: "73700", name: "MRI Right Ankle w/o contrast", modality: "MRI"},
      // { code: "73700", name: "MRI Right Ankle w/o contrast", modality: "MRI"},
      // { code: "73700", name: "MRI Right Ankle w/ contrast", modality: "MRI"},
      { id: 308, code: "73700", name: "MRI Both Ankles w/o contrast", modality: "MRI"},
      // { code: "73700", name: "MRI Both Ankles w/ contrast", modality: "MRI"},
      { id: 309, code: "73700", name: "MRI Both Ankles w/o and w/ contrast", modality: "MRI"},
      { id: 310, code: "73610", name: "Left Ankle (3 Views)", modality: "X-Ray" }, // AP, Lateral, and Mortise views
      { id: 311, code: "73610", name: "Right Ankle (3 Views)", modality: "X-Ray" },// AP, Lateral, and Mortise views
      { id: 312, code: "73610", name: "Both Ankles (3 Views)", modality: "X-Ray" },// AP, Lateral, and Mortise views
      { id: 313, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" }, 
      { id: 314, code: "77085", name: "Fracture Assessment Right", modality: "DEXA" },
    // ],
    // "Foot": [
      //{ code: "73620", name: "X-ray foot 2 views", modality: "X-Ray" }
      { id: 315, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      { id: 316, code: "73700", name: "MRI Left Foot w/o contrast", modality: "MRI"},
      { id: 317, code: "73700", name: "CT Left Foot w/o contrast", modality: "CT"},
      { id: 318, code: "73700", name: "CT Right Foot w/o contrast", modality: "CT"},
      // { code: "73700", name: "MRI Left Foot w/ contrast", modality: "MRI"},
      { id: 319, code: "73700", name: "MRI Left Foot w/o and w/ contrast", modality: "MRI"},
      { id: 320, code: "73700", name: "MRI Right Foot w/o contrast", modality: "MRI"},
      // { code: "73700", name: "MRI Right Foot w/ contrast", modality: "MRI"},
      { id: 321, code: "73700", name: "MRI Right Foot w/o and w/ contrast", modality: "MRI"},
      { id: 322, code: "73700", name: "MRI Both Feet w/o contrast", modality: "MRI"},
      // { code: "73700", name: "MRI Both Feet w/ contrast", modality: "MRI"},
      { id: 323, code: "73700", name: "MRI Both Feet w/o and w/ contrast", modality: "MRI"},
      { id: 324, code: "73630", name: "Left Foot (3 views)", modality: "X-Ray" },
      { id: 325, code: "73630", name: "Right Foot (3 views)", modality: "X-Ray" },
      { id: 326, code: "73630", name: "Both Feet (3 views)", modality: "X-Ray" },
      { id: 327, code: "73650", name: "Left Calcaneus (axial and lateral)", modality: "X-Ray"},
      { id: 328, code: "73650", name: "Right Calcaneus (axial and lateral)", modality: "X-Ray"},
      { id: 329, code: "73650", name: "Both Calcaneus (axial and lateral)", modality: "X-Ray"},
      { id: 330, code: "73650", name: "Left Calcaneus (2 views)", modality: "X-Ray"},
      { id: 331, code: "73650", name: "Right Calcaneus (2 views)", modality: "X-Ray"},
      { id: 332, code: "73650", name: "Both Calcaneus (2 views)", modality: "X-Ray"},
      { id: 333, code: "77085", name: "Fracture Assessment Left", modality: "DEXA" },
      { id: 334, code: "77085", name: "Fracture Assessment Right ", modality: "DEXA" },
    // ],
    // "Toes": [
      //{ code: "73660", name: "X-ray toes", modality: "X-Ray" }
      { id: 335, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      { id: 336, code: "73700", name: "MRI Left Toes 1-5 w/o contrast", modality: "MRI"},
      { id: 337, code: "73700", name: "MRI Left Toes 1-5 w/ contrast", modality: "MRI"},
      { id: 338, code: "73700", name: "MRI Left Toes 1-5 w/o and w/ contrast", modality: "MRI"},
      { id: 339, code: "73700", name: "MRI Right Toes 1-5 w/o contrast", modality: "MRI"},
      { id: 340, code: "73700", name: "MRI Right Toes 1-5 w/ contrast", modality: "MRI"},
      { id: 341, code: "73700", name: "MRI Right Toes 1-5 w/o and w/ contrast", modality: "MRI"},
      { id: 342, code: "73700", name: "MRI All Toes w/o contrast", modality: "MRI"},
      { id: 343, code: "73700", name: "MRI All Toes w/ contrast", modality: "MRI"},
      { id: 344, code: "73700", name: "MRI All Toes w/o and w/ contrast", modality: "MRI"},
      { id: 345, code: "73660", name: "Left Toes 1-5 (2-3 views)", modality: "X-Ray"},
      { id: 346, code: "73660", name: "Right Toes 1-5 (2-3 views)", modality: "X-Ray"},
      { id: 347, code: "77085", name: "Fracture Assessment Left 1-5 ", modality: "DEXA" }, 
      { id: 348, code: "77085", name: "Fracture Assessment Right 1-5", modality: "DEXA" },

      // Right Leg Doppler
      { id: 517, code: "93971", name: "Doppler Ultrasound Unilateral/Limited Study", modality: "US" },
      { id: 518, code: "93926", name: "Doppler Ultrasound Lower Extremity Arterial Unilateral/Limited Study", modality: "US" }
    ],
  "Chest / Thorax": 
  // {
  //   "Lungs": 
    [
      //{ code: "71045", name: "X-ray chest single view", modality: "X-Ray" },
      { id: 349, code: "71550", name: "Chest w/o contrast", modality: "MRI"},
      { id: 350, code: "71551", name: "Chest w/ contrast", modality: "MRI"},
      { id: 351, code: "71552", name: "Chest w/o and w/ contrast", modality: "MRI"},
      { id: 352, code: "71250", name: "CT chest w/o contrast", modality: "CT" },
      { id: 353, code: "71260", name: "CT chest with contrast", modality: "CT" },
      { id: 354, code: "71275", name: "CT Pulmonary Angiogram (CTPA)", modality: "CT" },
      { id: 355, code: "71046", name: "Chest X-Ray (PA and lateral)", modality: "X-Ray" },
      { id: 356, code: "71045", name: "Chest X-Ray (portable AP)", modality: "X-Ray" },
      { id: 357, code: "71048", name: "Chest (lateral decubitus view)", modality: "X-Ray"},
    // ],
    // "Heart": [
      { id: 358, code: "75571", name: "CT Coronary Calcium Score", modality: "CT" },
      { id: 359, code: "75574", name: "CT Coronary Angiogram (CTA Coronary)", modality: "CT" },
      { id: 360, code: "71250", name: "CT Hi Resolution chest w/o contrast", modality: "CT" },
      { id: 361, code: "71046", name: "Chest X-Ray (PA and lateral)", modality: "X-Ray" },
      { id: 362, code: "71045", name: "Chest X-Ray (portable AP)", modality: "X-Ray" },
      { id: 363, code: "93306", name: "Echocardiogram (Transthoracic)", modality: "US"},
      { id: 364, code: "76705", name: "Aorta/IVC", modality: "US"},
    // ],
    // "Ribs": [
      //{ code: "71100", name: "X-ray ribs unilateral", modality: "X-Ray" }
      { id: 365, code: "71100", name: "Unilateral ribs (2 views)", modality: "X-Ray" },
      { id: 366, code: "71101", name: "Unilateral ribs w/ chest", modality: "X-Ray" },
      { id: 367, code: "71110", name: "Bilateral ribs (3 views)", modality: "X-Ray" },
      { id: 368, code: "71111", name: "Bilateral ribs w/ chest", modality: "X-Ray" },
      { id: 369, code: "76641", name: "Ultrasound Breast (unilateral) Complete", modality: "US"},
      { id: 370, code: "76642", name: "Ultrasound Breast (unilateral) Limited", modality: "US"},
      { id: 371, code: "77085", name: "Fracture Assessment ", modality: "DEXA" },
    // ],
    // "Sternum": [
      //{ code: "71110", name: "X-ray sternum 2 views", modality: "X-Ray" }
      { id: 372, code: "73000", name: "Left Clavicle (Ap and axial)", modality: "X-Ray"},
      { id: 373, code: "73000", name: "Right Clavicle (Ap and axial)", modality: "X-Ray"},
      { id: 374, code: "73000", name: "Both Clavicles (Ap and axial)", modality: "X-Ray"},
      { id: 375, code: "73000", name: "Left Clavicle (2 views)", modality: "X-Ray"},
      { id: 376, code: "73000", name: "Right Clavicle (2 views)", modality: "X-Ray"},
      { id: 377, code: "73000", name: "Both Clavicles (2 views)", modality: "X-Ray"},
      { id: 378, code: "71120", name: "Sternum (lateral and oblique)", modality: "X-Ray"},
      { id: 379, code: "71120", name: "Sternum (2 views)", modality: "X-Ray"},
      { id: 380, code: "76641", name: "Ultrasound Breast (unilateral) Complete", modality: "US"},
      { id: 381, code: "76642", name: "Ultrasound Breast (unilateral) Limited", modality: "US"},
      { id: 382, code: "77085", name: "Fracture Assessment ", modality: "DEXA" },
    // ],
    // "Thoracic Aorta": [
      //{ code: "71275", name: "CTA chest (aorta)", modality: "CT" }
      { id: 383, code: "71555", name: "MRA Chest (aorta protocol)", modality: "MRI"},
      { id: 384, code: "76705", name: "Aorta/IVC", modality: "US"},
    ],
  "Abdomen / Pelvis": [
      //{ code: "74177", name: "CT abdomen & pelvis w/ contrast", modality: "CT" },
      //{ code: "76700", name: "Ultrasound abdomen complete", modality: "US" }
      { id: 385, code: "76170", name: "CT Abdomen w/ contrast", modality: "CT" },
      { id: 386, code: "76170", name: "CT Abdomen w/o contrast", modality: "CT" },
      { id: 387, code: "74183", name: "MRI Liver w/ contrast", modality: "MRI"},
      { id: 388, code: "74183", name: "MRI Liver w/o contrast", modality: "MRI"},
      { id: 389, code: "74183", name: "MRI Liver w/o and w/ contrast", modality: "MRI"},
      { id: 390, code: "74019", name: "Abdomen (upright and supine, 2 views)", modality: "X-Ray"},
      { id: 391, code: "76705", name: "Ultrasound Liver Elastography", modality: "US" },
      //{ code: "76775", name: "US retroperitoneal limited", modality: "US" }
      { id: 392, code: "74185", name: "MRA Abdomen(aorta or renal arteries)", modality: "MRI"},
      { id: 393, code: "74018", name: "Abdomen (KUB, 1 view)", modality: "X-Ray"},
      { id: 394, code: "74019", name: "Abdomen (upright and supine, 2 views)", modality: "X-Ray"},
      { id: 395, code: "76770", name: "Renal/Bladder Complete", modality: "US"},
      { id: 396, code: "76775", name: "Ultrasound Kidney/Retroperitoneum", modality: "US" },
      //{ code: "76857", name: "US pelvic limited (bladder)", modality: "US" }
      { id: 397, code: "74176", name: "CT Urogram w/o Contrast", modality: "CT" },
      { id: 398, code: "74177", name: "CT Urogram w/ Contrast", modality: "CT" },
      { id: 399, code: "74178", name: "CT Urogram w/o and w/ Contrast", modality: "CT" },
      { id: 400, code: "74018", name: "Abdomen (KUB, 1 view)", modality: "X-Ray"},
      { id: 401, code: "76857", name: "Bladder (post-void residual)", modality: "US"},
      { id: 402, code: "76770", name: "Renal/Bladder Complete", modality: "US"},

      //{ code: "74160", name: "CT abdomen w/ contrast", modality: "CT" }
      { id: 403, code: "76170", name: "CT Abdomen w/ Contrast", modality: "CT" },
      { id: 404, code: "76170", name: "CT Abdomen w/o Contrast", modality: "CT" },
      { id: 405, code: "74183", name: "MRI Pancreas w/ contrast", modality: "MRI"},
      { id: 406, code: "74183", name: "MRI Pancreas w/o contrast", modality: "MRI"},
      { id: 407, code: "74183", name: "MRI Pancreas w/o and w/ contrast", modality: "MRI"},
      { id: 408, code: "76705", name: "Ultrasound Pancreas", modality: "US"},
      { id: 409, code: "76775", name: "Ultrasound Kidney/Retroperitoneum", modality: "US" },
      { id: 410, code: "76705", name: "Ultrasound Spleen", modality: "US" },

      //{ code: "72192", name: "MRI pelvis w/o contrast", modality: "MRI" },
      //{ code: "72193", name: "MRI pelvis w/ contrast", modality: "MRI" },
      //{ code: "76705", name: "US Abdomen/Pelvis, limited", modality: "US"}
      { id: 411, code: "74177", name: "CT abdomen & pelvis w/ contrast", modality: "CT" },
      { id: 412, code: "74176", name: "CT abdomen & pelvis w/o contrast", modality: "CT" },
      { id: 413, code: "74176", name: "CT Urogram w/o Contrast", modality: "CT" },
      { id: 414, code: "74177", name: "CT Urogram w/ Contrast", modality: "CT" },
      { id: 415, code: "74178", name: "CT Urogram w/o and w/ Contrast", modality: "CT" },
      { id: 416, code: "72192", name: "CT Pelvis w/o contrast", modality: "CT" },
      { id: 417, code: "74174", name: "CT Angiogram (Abdomen/Pelvis)", modality: "CT" },
      { id: 418, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      { id: 419, code: "72198", name: "MRA Pelvis w/ contrast", modality: "MRI"},
      { id: 420, code: "72198", name: "MRA Pelvis w/o contrast", modality: "MRI"},
      { id: 421, code: "72198", name: "MRA Pelvis w/o and w/ contrast", modality: "MRI"},
      { id: 422, code: "72197", name: "MRI Pelvis w/ contrast", modality: "MRI"},
      { id: 423, code: "72197", name: "MRI Pelvis w/o contrast", modality: "MRI"},
      { id: 424, code: "72197", name: "MRI Pelvis w/o and w/ contrast", modality: "MRI"},
      { id: 425, code: "72197", name: "MRI Prostate (multiparametric)", modality: "MRI"},
      { id: 426, code: "72195", name: "MRI Female Pelvis w/ contrast (uterus/overies protocol)", modality: "MRI"},
      { id: 427, code: "72196", name: "MRI Female Pelvis w/o contrast (uterus/overies protocol)", modality: "MRI"},
      { id: 428, code: "72197", name: "MRI Female Pelvis w/o and w/ contrast (uterus/overies protocol)", modality: "MRI"},
      { id: 429, code: "72170", name: "Pelvis 2 view", modality: "X-Ray" },
      { id: 430, code: "72170", name: "Pelvis AP", modality: "X-Ray" },
      { id: 431, code: "72170", name: "Pelvis Inlet", modality: "X-Ray" },
      { id: 432, code: "72170", name: "Pelvis Outlet", modality: "X-Ray" },
      { id: 433, code: "72170", name: "Pelvis Judet", modality: "X-Ray" },
      { id: 434, code: "76856", name: "Ultrasound Pelvic Floor", modality: "US" },
      { id: 435, code: "76872", name: "Ultrasound Prostate (transrectal)", modality: "US" },
      { id: 436, code: "76870", name: "Ultrasound Scrotum/Testicles", modality: "US" },
      { id: 437, code: "76830", name: "Ultrasound Ovaries (follicle tracking) Transvaginal", modality: "US" },
      { id: 438, code: "76856", name: "Ultrasound Ovaries (follicle tracking) Pelvic Complete", modality: "US" },
      { id: 439, code: "76875", name: "Ultrasound Ovaries (follicle tracking) Limited", modality: "US" },
      { id: 440, code: "76815", name: "Ultrasound OB Limited", modality: "US" },
      { id: 441, code: "76805", name: "Ultrasound OB >14 Weeks", modality: "US" },
      { id: 442, code: "76801", name: "Ultrasound OB <14 Weeks", modality: "US" },
      { id: 443, code: "76856", name: "Ultrasound Pelvis  (transabdominal)", modality: "US" },
      { id: 444, code: "76830", name: "Ultrasound Pelvis (transvaginal)", modality: "US" },
      { id: 445, code: "76856", name: "Ultrasound Pelvis Transabdominal", modality: "US" },
      { id: 446, code: "76830", name: "Ultrasound Pelvis Transvaginal", modality: "US" },
      { id: 447, code: "77085", name: "Fracture Assessment ", modality: "DEXA" },

      { id: 448, code: "74177", name: "CT abdomen & pelvis w/ contrast", modality: "CT" },
      { id: 449, code: "76705", name: "Ultrasound App", modality: "CT" },

      //{ code: "74220", name: "Upper GI series", modality: "Fluoro" },
      //{ code: "74018", name: "KUB (Kidneys, Ureters, Bladder) X-ray", modality: "X-Ray" }
      { id: 450, code: "74018", name: "Abdomen (KUB, 1 view)", modality: "X-Ray"},
      // { code: "76705", name: "Ultrasound Abdomen Limited", modality: "US"},
      // { code: "76770", name: "Renal Retroperitoneal", modality: "US"},
      // { code: "76705", name: "Gallbladder", modality: "US"},
      // { code: "76856", name: "Pelvic Transabdominal", modality: "US"}
      { id: 497, code: "76700", name: "Ultrasound Abdomen Complete", modality: "US"},
      { id: 498, code: "76705", name: "Ultrasound Abdomen Limited", modality: "US"},
      { id: 499, code: "76770", name: "Ultrasound Renal Retroperitoneal", modality: "US"},
      { id: 500, code: "76705", name: "Ultrasound Gallbladder", modality: "US"},
      { id: 501, code: "76817", name: "Ultrasound Pelvic Transvaginal OB < 14 Weeks", modality: "US"},
      { id: 502, code: "76706", name: "Ultrasound Aorta", modality: "US"},

  ],
  "Vascular": 
  // {
  //   "Carotid Arteries": 
    [
      //{ code: "93880", name: "US duplex carotid arteries", modality: "US" }
      { id: 451, code: "93880", name: "Ultrasound Carotid Duplex (bilateral)", modality: "US"},
    // ],
    // "Abdominal Aorta": [
      //{ id: 450, code: "76770", name: "US retroperitoneal complete (aorta)", modality: "US" }
      { id: 452, code: "74185", name: "MRA Abdomen(aorta or renal arteries)", modality: "MRI"},
      { id: 453, code: "76706", name: "Ultrasound Aorta (abdominal aortic aneurysm screening)", modality: "US" },

    // ],
    // "Peripheral Arteries": [
      //{ code: "93923", name: "US duplex LE arteries", modality: "US" }
      { id: 454, code: "93926", name: "Ultrasound Left arterial duplex LE Limited", modality: "US" },
      { id: 455, code: "93925", name: "Ultrasound Left arterial duplex LE", modality: "US" },
      { id: 456, code: "93931", name: "Ultrasound Left arterial duplex UE Limited", modality: "US" },
      { id: 457, code: "93930", name: "Ultrasound Left arterial duplex UE", modality: "US" },
    // ],
    // "Venous Doppler Lower Extremities": [
      { id: 458, code: "93970", name: "Ultrasound Left duplex veins LE", modality: "US" },
    // ],
    // "Renal Arteries": [
      //{ code: "93975", name: "Doppler US renal vascular study", modality: "US" }
      { id: 459, code: "74185", name: "MRA Abdomen(aorta or renal arteries)", modality: "MRI"},

      // Lower Extremity Vascular
      { id: 503, code: "93970", name: "Ultrasound Right Lower Extremity Venous Doppler", modality: "US"},
      { id: 504, code: "93970", name: "Ultrasound Left Lower Extremity Venous Doppler", modality: "US"},
      { id: 505, code: "93970", name: "Ultrasound Bilateral Lower Extremity Venous Doppler", modality: "US"},
      { id: 506, code: "93925", name: "Ultrasound Right Lower Extremity Arterial Doppler", modality: "US"},
      { id: 507, code: "93925", name: "Ultrasound Left Lower Extremity Arterial Doppler", modality: "US"},
      { id: 508, code: "93926", name: "Ultrasound Bilateral Lower Extremity Arterial Doppler", modality: "US"},

      // Upper Extremity Vascular
      { id: 509, code: "93971", name: "Ultrasound Right Upper Extremity Venous Doppler", modality: "US"},
      { id: 510, code: "93971", name: "Ultrasound Left Upper Extremity Venous Doppler", modality: "US"},
      { id: 511, code: "93930", name: "Ultrasound Bilateral Upper Extremity Venous Doppler", modality: "US"},
      { id: 512, code: "93931", name: "Ultrasound Right Upper Extremity Arterial Doppler", modality: "US"},
      { id: 513, code: "93931", name: "Ultrasound Left Upper Extremity Arterial Doppler", modality: "US"},
      { id: 514, code: "93930", name: "Ultrasound Bilateral Upper Extremity Arterial Doppler", modality: "US"},
    ]
  , "Soft Tissue / Foreign Body": 
  // {
  //   "Extremities": 
    [
      //{ code: "76010", name: "X-ray for foreign body localization", modality: "X-Ray" }
      { id: 460, code: "76536", name: "Ultrasound Soft Tissue", modality: "US" },
      { id: 461, code: "73725", name: "MRA Lower Extremities (runoff) Left", modality: "MRI" },
      { id: 462, code: "73725", name: "MRA Lower Extremities (runoff) Right", modality: "MRI" },
      { id: 463, code: "73725", name: "MRA Lower Extremities (runoff) Both", modality: "MRI" },
      { id: 464, code: "76881", name: "Ultrasound Upper Extremities Left Complete", modality: "US" },
      { id: 465, code: "76881", name: "Ultrasound Upper Extremities Right Complete", modality: "US" },
      { id: 466, code: "76881", name: "Ultrasound Upper Extremities Both Complete", modality: "US" },
      { id: 467, code: "76882", name: "Ultrasound Upper Extremities Left Limited", modality: "US" },
      { id: 468, code: "76882", name: "Ultrasound Upper Extremities Right Limited", modality: "US" },
      { id: 469, code: "76882", name: "Ultrasound Upper Extremities Both Limited", modality: "US" },
      { id: 470, code: "76881", name: "Ultrasound Lower Extremities Left Complete", modality: "US" },
      { id: 471, code: "76881", name: "Ultrasound Lower Extremities Right Complete", modality: "US" },
      { id: 472, code: "76881", name: "Ultrasound Lower Extremities Both Complete", modality: "US" },
      { id: 473, code: "76882", name: "Ultrasound Lower Extremities Left Limited", modality: "US" },
      { id: 474, code: "76882", name: "Ultrasound Lower Extremities Right Limited", modality: "US" },
      { id: 475, code: "76882", name: "Ultrasound Lower Extremities Both Limited", modality: "US" },
      { id: 476, code: "93970", name: "Ultrasound Left duplex veins LE", modality: "US" },  // Might need mod-59 if billed together
      { id: 477, code: "93970", name: "Ultrasound Right duplex veins LE", modality: "US" }, // Might need mod-59 if billed together
      { id: 478, code: "93970", name: "Ultrasound Left duplex veins UE", modality: "US" },  // Might need mod-59 if billed together
      { id: 479, code: "93970", name: "Ultrasound Right duplex veins UE", modality: "US" }, // Might need mod-59 if billed together
      { id: 480, code: "77081", name: "Appendicular Upper Extremities", modality: "DEXA" },
      { id: 481, code: "77081", name: "Appendicular Lower Extremities", modality: "DEXA" },
      { id: 482, code: "77085", name: "Fracture Assessment", modality: "DEXA" },
    // ],
    // "Neck": [
      //{ code: "70370", name: "Soft tissue neck X-ray", modality: "X-Ray" }
      { id: 483, code: "76536", name: "Ultrasound Soft Tissue", modality: "US" },
      { id: 484, code: "77085", name: "Fracture Assessment ", modality: "DEXA" },
    // ],
    // "Abdomen": [
      //{ code: "74022", name: "X-ray abdomen series (foreign body eval)", modality: "X-Ray" }
      { id: 485, code: "76536", name: "Ultrasound Soft Tissue", modality: "US" },
      { id: 486, code: "74174", name: "CT Angiogram (Abdomen/Pelvis)", modality: "CT" },
      { id: 487, code: "74175", name: "CT Angiogram (Abdomen/Pelvis) w/o and with", modality: "CT" },
      { id: 488, code: "75635", name: "CT Angiogram (Runoff - Abdomen/Pelvis/Lower Extremities)", modality: "CT" },
      // { code: "74183", name: "MRI Abdomen w/ contrast", modality: "MRI"},
      { id: 489, code: "74183", name: "MRI Abdomen w/o contrast", modality: "MRI"},
      { id: 490, code: "74183", name: "MRI Abdomen w/o and w/ contrast", modality: "MRI"},
      { id: 491, code: "74183", name: "MRI Abdomen and MRCP", modality: "MRI"},
      { id: 492, code: "76705", name: "Ultrasound Abdominal Wall", modality: "US"},
      { id: 493, code: "76705", name: "Ultrasound Hernia", modality: "US"},
      { id: 494, code: "76700", name: "Ultrasound Abdomen Complete", modality: "US" },
      { id: 495, code: "76705", name: "Ultrasound Abdomen Limited (RUQ)", modality: "US" },
    // ],
    // "Orbits": [
      //{ code: "70160", name: "X-ray orbit (foreign body detection)", modality: "X-Ray" }
      { id: 496, code: "76536", name: "Ultrasound Soft Tissue", modality: "US" }
    ],

  "Full Body": [
    { id: 515, code: "77084", name: "MRI Full Body Screening", modality: "MRI"},
    { id: 516, code: "76499", name: "DEXA Full Body Screening", modality: "DEXA"}
  ]
  // }
};

/*
  This React component:
  • Renders three dropdowns: one for modality, one for body part, and one for the CPT codes.
  • When both modality and body part are selected, it fetches the relevant CPT codes from our API.
  • It also shows additional checkboxes for options like contrast or sedation.
*/
const NewImagingOrder = () => {
  const api = {
    searchPatients: async (query, user, type) => {

      // In Development, we can use an API call to fetch patients
      
      try {
        const response = await fetch(`${BASE_URL}/ris/search?pat=${query}&user=${user}&type=${type}`);
        const data = await response.json();
        if (response.status == 200) {
          return data;
        }
        else {
          setSelectedPatient(false);
          return [];
        }
      }
      catch (error) {
        logger.error("Error fetching patients:", error);
      }
    },
  }
    const {currentUser, setCurrentUser, setCurrentPatient} = useContext(GlobalStateContext);
    // const {currentAppointment} = useContext(ClinicianContext);
    const [modality, setModality] = useState("");
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedBodyPart, setSelectedBodyPart] = useState("");
    const BASE_URL = process.env.REACT_APP_API_URL;
    // const [cptCodes, setCptCodes] = useState([]);
    const [cptCodesFiltered, setCptCodesFiltered] = useState([]);
    const [cptCode, setCptCode] = useState("");
    const [selectedExamId, setSelectedExamId] = useState("");
    const [examOrdered, setExamOrdered] = useState("");
    const [priority, setPriority] = useState("Routine");
    const [options, setOptions] = useState("");
    const [notes, setNotes] = useState("");
    const [clinicalHistory, setClinicalHistory] = useState("");
    const [orderingClinician, setOrderingClinician] = useState("");
    const [referringProvider, setReferringProvider] = useState("");
    const [surgicalHistory, setSurgicalHistory] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(false);
    const [scannedFile, setScannedFile] = useState(null);
    const [pendingDocuments, setPendingDocuments] = useState([]);
    const [pendingDocsSessionId, setPendingDocsSessionId] = useState(null);
    // const [isObtained, setIsObtained] = useState(false);
    // const [toBeObtained, setToBeObtained] = useState(false);
    const [demographics, setDemographics] = useState({
      first_name: '',
      last_name: '',
      email: '',
      primary_phone: '',
      dob: '',
      sex: ''
    });
    const [validationErrors, setValidationErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'

    // Catalog hook — merges hardcoded maps with DB custom entries + overrides
    const { mergedAnatomicalMap, mergedRegionBodyPartsMap, refetchCatalog } =
        useImagingCatalog(anatomicalMap, regionBodyPartsMap);

    // Modal state
    const [showAddBodyPart, setShowAddBodyPart] = useState(false);
    const [showAddOrder, setShowAddOrder] = useState(false);
    const [changeRequestEntry, setChangeRequestEntry] = useState(null);

    // ── Auto-fax to referring facility ────────────────────────────────────────
    // When the report lands in our PACS, the report consumer auto-faxes it to the
    // facility's number if auto_fax is on. The checkbox defaults ON whenever a valid
    // fax number is present, but the user can override it (tracked so we stop
    // auto-syncing once they've made an explicit choice).
    const [facilities, setFacilities] = useState([]);
    const [selectedFacilityId, setSelectedFacilityId] = useState("");
    const [faxNumber, setFaxNumber] = useState("");
    const [autoFax, setAutoFax] = useState(false);
    const [autoFaxManuallySet, setAutoFaxManuallySet] = useState(false);
    const [showAddFacility, setShowAddFacility] = useState(false);
    const [newFacility, setNewFacility] = useState({ name: '', fax_number: '' });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // const id = currentPatient.patient[0].patients_id;
    // const appt_id = currentAppointment;
    const user = getUserId(currentUser);


  useEffect(() => {
    setCurrentPatient(null);
  }, []);

  useEffect(() => {
    if (selectedPatient) {
      setCurrentPatient({ ris_patients_id: selectedPatient.ris_patients_id || selectedPatient.id });
    } else {
      setCurrentPatient(null);
    }
  }, [selectedPatient]);

  useEffect(() => {
    if (!selectedRegion || !modality) {
      setCptCodesFiltered([]);
      setCptCode("");
      setExamOrdered("");
      setSelectedExamId("");
      return;
    }

    const regionCpts = mergedAnatomicalMap[selectedRegion] || [];
    const filtered = regionCpts.filter((item) => item.modality === modality);

    setCptCodesFiltered(filtered);
    setCptCode("");
    setExamOrdered("");
    setSelectedExamId("");
  }, [selectedRegion, modality, mergedAnatomicalMap]);

  // useEffect(() => {
  //   logger.log(JSON.stringify(currentUser.clinicians_id))
  // })

  // Load the active referring-facility directory for the fax dropdown.
  useEffect(() => {
    const loadFacilities = async () => {
      try {
        const response = await fetch(`${BASE_URL}/referringFacilities`);
        if (response.ok) {
          const data = await response.json();
          setFacilities(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        logger.error("Error loading referring facilities:", error);
      }
    };
    loadFacilities();
  }, []);

  // A fax number is "valid enough" to auto-enable faxing once it has 10+ digits.
  const isValidFax = (value) => (value || '').replace(/\D/g, '').length >= 10;

  // Set the fax number and, unless the user has explicitly chosen, keep the auto-fax
  // checkbox in sync with whether a valid number is present.
  const updateFaxNumber = (value) => {
    setFaxNumber(value);
    if (!autoFaxManuallySet) setAutoFax(isValidFax(value));
  };

  const handleFacilityChange = (e) => {
    const id = e.target.value;
    setSelectedFacilityId(id);
    const facility = facilities.find((f) => String(f.id) === String(id));
    // Pre-fill the (editable) fax number from the selected facility.
    updateFaxNumber(facility?.fax_number || '');
  };

  const handleAutoFaxToggle = (e) => {
    setAutoFax(e.target.checked);
    setAutoFaxManuallySet(true);
  };

  // Inline "add facility" — create a facility, select it, and pre-fill its fax number
  // without leaving the referral form.
  const handleAddFacility = async () => {
    if (!newFacility.name.trim()) {
      toast.error('Facility name is required.', { position: 'top-center', autoClose: 3000 });
      return;
    }
    try {
      const response = await fetch(`${BASE_URL}/referringFacilities`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: newFacility.name.trim(),
          fax_number: newFacility.fax_number.trim() || null,
          user,
          type: currentUser.type,
        }),
      });
      if (!response.ok) throw new Error('Create failed');
      const created = await response.json();
      setFacilities((prev) => [...prev, created].sort((a, b) => (a.name || '').localeCompare(b.name || '')));
      setSelectedFacilityId(String(created.id));
      updateFaxNumber(created.fax_number || '');
      setNewFacility({ name: '', fax_number: '' });
      setShowAddFacility(false);
      toast.success('Facility added.', { position: 'top-center', autoClose: 2000 });
    } catch (error) {
      logger.error("Error adding facility:", error);
      toast.error('Could not add facility. Please try again.', { position: 'top-center', autoClose: 3000 });
    }
  };

  const handleOptionsChange = (event) => {
    const { value, checked } = event.target;
    setOptions(checked ? [...options, value] : options.filter(opt => opt !== value));
  };

  const handleSearch = async (query) => {
    setSearchQuery(query);
    // Debounce search to avoid too many API calls
    //need to add search button to make less API calls
      const results = await api.searchPatients(query, user, currentUser.type);
      // logger.log(results)
      setPatients(results);
  };

  const validateForm = () => {
    const errors = {};

    if (!selectedPatient) {
      if (!demographics.first_name.trim()) errors.first_name = "First name is required";
      if (!demographics.last_name.trim()) errors.last_name = "Last name is required";
      if (!demographics.dob) errors.dob = "Date of birth is required";
      if (!demographics.sex) errors.sex = "Sex is required";
    }

    if (!orderingClinician.trim()) errors.orderingClinician = "Ordering clinician name is required";
    if (!referringProvider.trim()) errors.referringProvider = "Referring provider is required";
    if (!modality) errors.modality = "Modality is required";
    if (!selectedRegion) errors.selectedRegion = "Region is required";
    if (!cptCode) errors.cptCode = "CPT code / exam selection is required";
    if (!clinicalHistory.trim()) errors.clinicalHistory = "Clinical history is required";

    return errors;
  };

    const handleSubmit = async (e) => {
      e.preventDefault();

      const errors = validateForm();
      if (Object.keys(errors).length > 0) {
        setValidationErrors(errors);
        toast.error('Please fill in all required fields before submitting.', {
          position: 'top-center',
          autoClose: 4000,
        });
        return;
      }
      setValidationErrors({});
      setSubmitStatus('loading');

      const postBody = {orderingClinician, referringProvider, modality, selectedRegion, selectedBodyPart, cptCode,
                options, notes, clinicalHistory, priority, examOrdered, type: currentUser.type, user, selectedPatient,
                referring_facility_id: selectedFacilityId || null,
                fax_number: faxNumber.trim() || null,
                // Only enable auto-fax when the number is actually usable, regardless of
                // the checkbox's last state (it can be left checked after digits are removed).
                auto_fax: autoFax && isValidFax(faxNumber)}

      try {
        const response = await fetch(`${BASE_URL}/patientRegistrationReferred/postDemographics`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({postBody, demographics}),
        });
        if (response.ok) {
          const data = await response.json();
          logger.log("Added order successfully: ", data)
          setSubmitStatus('success');

          // If there are pending documents and a patient was created, upload them
          if (pendingDocsSessionId && pendingDocuments.length > 0 && data.ris_patients_id) {
            logger.log("Uploading pending documents for new patient...");
            try {
              const uploadResult = await uploadPendingDocuments(
                pendingDocsSessionId,
                data.ris_patients_id,
                currentUser.type,
                user,
                data.radiology_orders_id,
                'Radiology'
              );

              if (uploadResult.success) {
                logger.log(`Successfully uploaded ${uploadResult.uploaded.length} documents`);
                if (uploadResult.failed.length > 0) {
                  logger.warn(`Failed to upload ${uploadResult.failed.length} documents`, uploadResult.failed);
                }
              } else {
                logger.error("Failed to upload pending documents:", uploadResult.error);
              }
            } catch (uploadError) {
              logger.error("Error uploading pending documents:", uploadError);
            }
          }

          // Auto-select the newly created patient so subsequent orders don't duplicate them
          if (!selectedPatient && data.ris_patients_id) {
            setSelectedPatient({
              ris_patients_id: data.ris_patients_id,
              first_name: demographics.first_name,
              last_name: demographics.last_name,
              phone_number: demographics.primary_phone,
              dob: demographics.dob,
              email: demographics.email,
              sex: demographics.sex,
            });
            setDemographics({
              first_name: '',
              last_name: '',
              email: '',
              primary_phone: '',
              dob: '',
              sex: ''
            });
          }
        } else {
          setSubmitStatus('error');
        }
      } catch (error) {
        logger.error("Error adding patient notes", error);
        setSubmitStatus('error');
        }
  }

  const handlePendingDocumentsChange = (docs, sessionId) => {
    setPendingDocuments(docs);
    setPendingDocsSessionId(sessionId);
  }
  
  const formattedText = surgicalHistory
    .split("||")
    .map((item, index) => `${index + 1}. ${item}`)
    .join("\n");

  return (
  <>
    {/* SEARCH BAR */}
    <div className="modality-container">
        {/* <div className="navigation-intake">
    <Link to={"/home"}><button className="PrimaryButton">Home</button></Link>
    <Link to={"/checkIn"}><button className="PrimaryButton">Check In</button></Link>
    <Link to={"/orders"}><button className="PrimaryButton">Orders</button></Link>
          </div> */}
    <div className="logo-intake-header">
        <img src={HGI} alt='HGI LOGO' style={{ width: '120px', height: '120px' }}/>
        <h1>Referred Patient Intake Form</h1>
    </div>
  {/* <div className="ris-orders-form-group">
      <label>Referred Patient Upload Order:</label>
      <GCSDocumentManager />
      {scannedFile && <span>File uploaded: {scannedFile}</span>}
    </div> */}
    <div>
      <h3>Returning Patient Search</h3>
      <div className="search-patient">
      <input
        type="text"
        placeholder="Search for RIS Patients"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)} // Corrected handler
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
              // Your search logic here
              handleSearch(searchQuery);
          }
        }}
        className="search-input"
      />
      <button className='schedule-button' onClick={() => handleSearch(searchQuery)}>Search</button>
    </div>
      <ul className="patient-list">
        {patients.map((patient) => (
          <li
            key={patient.id}
            onClick={() => setSelectedPatient(patient)}
            className="patient-item"
          >
            {patient.first_name} {patient.last_name} | {patient.dob} | {patient.street_number} {patient.street_name}
          </li>
        ))}
      </ul>
    </div>
    

    <form onSubmit={handleSubmit}>
      {selectedPatient ? <>
      <h2>Demographic Info</h2>
        <div className="label-container">
          <span>
            <label><strong>First Name: </strong></label>
            {selectedPatient.first_name}
          </span>
          <span>
            <label><strong>Last Name: </strong></label>
            {selectedPatient.last_name}</span>
          <span>
            <label><strong>Phone Number: </strong></label>
            {selectedPatient.phone_number}</span>
          <span>
            <label><strong>Date Of Birth: </strong></label>
            {selectedPatient.dob}</span>
          <span>
            <label><strong>Email: </strong></label>
            {selectedPatient.email}</span>
          <span>
            <label><strong>Sex: </strong></label>
            {selectedPatient.sex}</span>
        </div>
        </> : <>
        <h2>Demographic Info</h2>
        <div className="label-container">
          <div>
            <label className="label-field">First Name <span style={{color:'red'}}>*</span></label>
            <input
              type="text"
              placeholder="First Name"
              value={demographics.first_name}
              onChange={(e) => setDemographics((prev) => ({...prev, first_name: e.target.value}))}
              className="imaging-order-notes"
              style={{width:'100%', boxSizing:'border-box'}}
              />
            {validationErrors.first_name && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.first_name}</span>}
          </div>
          <div>
            <label className="label-field">Last Name <span style={{color:'red'}}>*</span></label>
            <input
              type="text"
              placeholder="Last Name"
              value={demographics.last_name}
              onChange={(e) => setDemographics((prev) => ({...prev, last_name: e.target.value}))}
              className="imaging-order-notes"
              style={{width:'100%', boxSizing:'border-box'}}
              />
            {validationErrors.last_name && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.last_name}</span>}
          </div>
          <div>
            <label className="label-field">Phone Number</label>
            <InputMask
              mask="(XXX) XXX-XXXX"
              replacement={{ X: /\d/ }}
              type="text"
              placeholder="(___) ___-____"
              value={demographics.primary_phone}
              onChange={(e) => setDemographics((prev) => ({...prev, primary_phone: e.target.value}))}
              className="imaging-order-notes"
              style={{width:'100%', boxSizing:'border-box'}}
              />
          </div>
          <div>
            <label className="label-field">Date of Birth <span style={{color:'red'}}>*</span></label>
            <input
              type="date"
              value={demographics.dob}
              onChange={(e) => setDemographics((prev) => ({...prev, dob: e.target.value}))}
              className="imaging-order-notes"
              style={{width:'100%', boxSizing:'border-box'}}
              />
            {validationErrors.dob && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.dob}</span>}
          </div>
          <div>
            <label className="label-field">Email Address</label>
            <input
              type="text"
              placeholder="Email Address"
              value={demographics.email}
              onChange={(e) => setDemographics((prev) => ({...prev, email: e.target.value}))}
              className="imaging-order-notes"
              style={{width:'100%', boxSizing:'border-box'}}
              />
          </div>
          <div>
            <label className="label-field">Sex <span style={{color:'red'}}>*</span></label>
            <select
              value={demographics.sex}
              onChange={(e) => setDemographics((prev) => ({...prev, sex: e.target.value}))}
              className="imaging-order-notes"
              style={{width:'100%', boxSizing:'border-box'}}
            >
              <option value={""}>Select Sex</option>
              <option value={"Male"}>Male</option>
              <option value={"Female"}>Female</option>
            </select>
            {validationErrors.sex && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.sex}</span>}
          </div>
        </div>
        </>
      }
      <h2>Radiology Exam Information</h2>
        <div className="field">
          <label className="label-field">Name of Ordering Clinician: <span style={{color:'red'}}>*</span></label>
          <input
            type="text"
            value={orderingClinician}
            onChange={(e) => setOrderingClinician(e.target.value)}
            className="imaging-order-description-notes"
            placeholder="Ordering Clinician Name"
            />
          {validationErrors.orderingClinician && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.orderingClinician}</span>}
        </div>

        <div className="field">
          <label className="label-field">Referring Provider: <span style={{color:'red'}}>*</span></label>
          <input
            type="text"
            value={referringProvider}
            onChange={(e) => setReferringProvider(e.target.value)}
            className="imaging-order-description-notes"
            placeholder="Referring Provider Name"
            />
          {validationErrors.referringProvider && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.referringProvider}</span>}
        </div>

        {/* Referring Facility + Auto-fax destination.
            When the finalized report lands in our PACS, it is auto-faxed here if
            "Auto-fax" is checked. Selecting a facility pre-fills its saved fax number
            (still editable). Leave blank for no fax. */}
        <div className="field">
          <label className="label-field">Referring Facility (for report fax):</label>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <select
              className="select-field"
              value={selectedFacilityId}
              onChange={handleFacilityChange}
              style={{ flex: 1 }}
            >
              <option value="">Select a facility (optional)</option>
              {facilities.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.name}{f.fax_number ? ` — ${f.fax_number}` : ' (no fax on file)'}
                </option>
              ))}
            </select>
            <button
              type="button"
              className="add-facility-btn"
              onClick={() => setShowAddFacility((v) => !v)}
              style={{ whiteSpace: 'nowrap' }}
            >
              {showAddFacility ? 'Cancel' : '+ Add facility'}
            </button>
          </div>
        </div>

        {showAddFacility && (
          <div className="field" style={{ background: '#f6f8fa', padding: '10px', borderRadius: '6px' }}>
            <label className="label-field">New Facility</label>
            <input
              type="text"
              className="imaging-order-description-notes"
              placeholder="Facility name"
              value={newFacility.name}
              onChange={(e) => setNewFacility((prev) => ({ ...prev, name: e.target.value }))}
            />
            <input
              type="text"
              className="imaging-order-description-notes"
              placeholder="Fax number (e.g. (417) 201-2659)"
              value={newFacility.fax_number}
              onChange={(e) => setNewFacility((prev) => ({ ...prev, fax_number: e.target.value }))}
              style={{ marginTop: '6px' }}
            />
            <button type="button" className="add-facility-btn" onClick={handleAddFacility} style={{ marginTop: '6px' }}>
              Save facility
            </button>
          </div>
        )}

        <div className="field">
          <label className="label-field">Fax Number:</label>
          <input
            type="text"
            value={faxNumber}
            onChange={(e) => updateFaxNumber(e.target.value)}
            className="imaging-order-description-notes"
            placeholder="Destination fax number (optional)"
          />
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px', fontSize: '0.9em', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={autoFax}
              onChange={handleAutoFaxToggle}
              disabled={!isValidFax(faxNumber)}
              style={{ width: 'auto' }}
            />
            Auto-fax report to this number when finalized
          </label>
          {autoFax && !isValidFax(faxNumber) && (
            <span style={{ color: '#b26a00', fontSize: '0.8em' }}>
              Enter a valid fax number (10+ digits) to enable auto-faxing.
            </span>
          )}
        </div>

        {/* Modality Dropdown */}
        <div className="field">
          <label className="label-field">Modality: <span style={{color:'red'}}>*</span></label>
          <select
            className="select-field"
            value={modality}
            onChange={(e) => {
              setModality(e.target.value);
              setSelectedBodyPart(""); // Reset body part when modality changes.
            }}
          >
            <option value="">Select Modality</option>
            {modalities.map((mod) => (
              <option key={mod} value={mod}>
                {mod}
              </option>
            ))}
          </select>
          {validationErrors.modality && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.modality}</span>}
        </div>

         {/* Region Dropdown */}
         <div className="field">
          <label className="label-field">Region: <span style={{color:'red'}}>*</span></label>
         {/* <select
            className="select-field"
            value={selectedRegion}
            onChange={(e) => {
              setSelectedRegion(e.target.value);
              setSelectedBodyPart("");
            }}
            disabled={!modality || isSubmitting}
          >
            <option value="">Select Region</option>
            {Object.keys(anatomicalMap).map((region) => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
          </select>*/}
        
        <select
          className="select-field"
          value={selectedRegion}
          onChange={(e) => {
            setSelectedRegion(e.target.value);
            setSelectedBodyPart("");
            setCptCode("");
          }}
          disabled={!modality}
        >
          <option value="">Select Region</option>
          {Object.keys(mergedAnatomicalMap).map((region) => (
            <option key={region} value={region}>
              {region}
            </option>
          ))}
        </select>
        {validationErrors.selectedRegion && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.selectedRegion}</span>}
        </div>


        {/* Body Part Dropdown */}
         <div className="field">
          <label className="label-field">Body Part:</label>
          {/*<select
            className="select-field"
            value={selectedBodyPart}
            onChange={(e) => setSelectedBodyPart(e.target.value)}
            disabled={!selectedRegion || isSubmitting}
          >
            <option value="">Select Body Part</option>
            {Object.keys(anatomicalMap[selectedRegion] || {}).map((bp) => (
              <option key={bp} value={bp}>
                {bp}
              </option>
            ))}
          </select>*/}
        
        <select
          className="select-field"
          value={selectedBodyPart}
          onChange={(e) => setSelectedBodyPart(e.target.value)}
          disabled={!selectedRegion}
        >
          <option value="">Select Body Part</option>
          {(mergedRegionBodyPartsMap[selectedRegion] || []).map(bp => (
            <option key={bp} value={bp}>{bp}</option>
          ))}
        </select>
        <div className="im-trigger-row">
          <button
            type="button"
            className="im-trigger-btn"
            onClick={() => setShowAddBodyPart(true)}
          >
            + Add Body Part
          </button>
        </div>

        </div>


        {/* CPT Code Dropdown */}
         <div className="field">
          <label className="label-field">CPT Code: <span style={{color:'red'}}>*</span></label>
          {/* <select
            className="select-field"
            value={cptCode}
            onChange={(e) => {
              setCptCode(e.target.value)
              const selectedCpt = cptCodesFiltered.find(code => code.code === e.target.value);
              if (selectedCpt) {
                setExamOrdered(selectedCpt.name);
              }
            }}
            disabled={!cptCodesFiltered.length || isSubmitting}
          >
            <option value="">Select CPT Code</option>
            {cptCodesFiltered.map(({ code, name }) => (
              <option key={code} value={code}>
                {code} – {name}
              </option>
            ))}
          </select> */}
          <select
          className="select-field"
          value={selectedExamId}
          onChange={(e) => {
            const id = Number(e.target.value);
            const selected = cptCodesFiltered.find(c => c.id === id);
            if (selected) {
              setSelectedExamId(id);
              setCptCode(selected.code);
              setExamOrdered(selected.name);
            }
          }}
          disabled={!cptCodesFiltered.length}
        >
          <option value="">Select CPT Code</option>
          {(() => {
            const seen = new Set();
            return cptCodesFiltered
              .filter(({ code, name }) => {
                const key = `${code}|${name}`;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
              })
              .map(({ id, code, name }) => (
                <option key={id} value={id}>
                  {code} – {name}
                </option>
              ));
          })()}
        </select>
        {selectedExamId && (
          <button
            type="button"
            className="im-change-request-link"
            onClick={() => {
              const selected = cptCodesFiltered.find(c => c.id === selectedExamId);
              if (selected) {
                setChangeRequestEntry({ ...selected, region: selectedRegion });
              }
            }}
          >
            Request change to this entry
          </button>
        )}
        <div className="im-trigger-row">
          <button
            type="button"
            className="im-trigger-btn"
            onClick={() => setShowAddOrder(true)}
          >
            + Add Custom Order
          </button>
        </div>
        {validationErrors.cptCode && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.cptCode}</span>}
        </div>

      <div className="field">
       <label className="label-field">Priority:</label>
        <select
          className="select-field"
          value={priority}
          onChange={(e) => setPriority(e.target.value)}>
          <option value="Routine">
            Routine
          </option>
          <option value="STAT">
            STAT
          </option>
          <option value="Stroke">
            Stroke
          </option>
          <option value ="Trauma">
            Trauma
          </option>
          <option value ="Next Day">
            Next Day
          </option>
          <option value ="2 Day">
            2 day
          </option>
        </select>
      </div>

        {/* Additional Options */}
        <fieldset className="options">
          <legend>Additional Options</legend>
          {["IV Gadolinium","IV Contrast", "Oral Contrast", "Enteric Contrast", "Sedation", "Fluids"].map((opt) => (
            <label className="label-field" key={opt}>
              <input
                type="checkbox"
                value={opt}
                checked={options.includes(opt)}
                onChange={handleOptionsChange}
              />
              {opt}
            </label>
          ))}
        </fieldset>
        {/* <div className="field">
          <label> 
            <input
              type="checkbox"
              checked={isObtained}
              onChange={(e) => setIsObtained(e.target.checked)}
            />
            Obtained
          </label>
          <label style={{ marginLeft: "1rem" }}>
            <input
              type="checkbox"
              checked={toBeObtained}
              onChange={(e) => setToBeObtained(e.target.checked)}
            />
            To Be Obtained
          </label>
        </div> */}
          {/* clinical history section */}
        <div className="field">
          <label className="label-field">Clinical History: <span style={{color:'red'}}>*</span></label>
          <textarea
            type="text"
            value={clinicalHistory}
            onChange={(e) => setClinicalHistory(e.target.value)}
            className="imaging-order-description-notes"
            rows={4}
            />
          {validationErrors.clinicalHistory && <span style={{color:'red', fontSize:'0.8em'}}>{validationErrors.clinicalHistory}</span>}
        </div>
          {/* notes section */}
        <div className="field">
          <label className="label-field">Notes:</label>
          <input
            type="text"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="imaging-order-description-notes"
            />
        </div>

        <div>
          <label className="label-field">Upload Order:</label>
          <GCSDocumentManager onPendingDocumentsChange={handlePendingDocumentsChange} />
        </div>
        
        {submitStatus === 'success' && (
          <p style={{color:'green', fontWeight:'bold'}}>Order submitted successfully!</p>
        )}
        {submitStatus === 'error' && (
          <p style={{color:'red', fontWeight:'bold'}}>Submission failed. Please try again or contact support.</p>
        )}
          <button
            type="submit"
            style={{'margin-top': '1vh'}}
            className="PrimaryButton"
            disabled={submitStatus === 'loading'}
          >
            {submitStatus === 'loading' ? 'Submitting...' : 'Submit Order'}
          </button>
      </form>
    </div>
    <ToastContainer />

    <AddBodyPartModal
      isOpen={showAddBodyPart}
      onClose={() => setShowAddBodyPart(false)}
      onSuccess={refetchCatalog}
      user={user}
    />

    <AddImagingOrderModal
      isOpen={showAddOrder}
      onClose={() => setShowAddOrder(false)}
      onSuccess={refetchCatalog}
      preselectedRegion={selectedRegion}
      preselectedModality={modality}
      user={user}
    />

    <ImagingChangeRequestModal
      isOpen={!!changeRequestEntry}
      onClose={() => setChangeRequestEntry(null)}
      entry={changeRequestEntry}
      entryType={changeRequestEntry && String(changeRequestEntry.id).startsWith("custom_") ? "custom" : "base"}
      user={user}
    />
    </>
  );
};

export default NewImagingOrder;